const es = {
  common: {
    nav: { services: "Servicios", about: "Nosotros", guides: "Guías", contact: "Contacto" },
    cta: "Iniciar proyecto",
    language: "Idioma",
    themeToLight: "Cambiar a modo claro",
    themeToDark: "Cambiar a modo oscuro",
    menuOpen: "Abrir menú",
    menuClose: "Cerrar menú",
    optional: "opcional",
    reply: "Respondemos en menos de 7 horas.",
    scroll: "Desliza",
  },
  footer: {
    tagline: "Automatización con IA, webs y apps para equipos que quieren que los sistemas hagan el trabajo repetitivo.",
    company: "Empresa",
    policies: "Políticas",
    elsewhere: "Redes",
    location: "Bikaner, Rajastán, India · Trabajamos en todo el mundo",
    legal: {
      terms: "Términos y condiciones",
      privacy: "Política de privacidad",
      refund: "Política de reembolso",
      return: "Política de devoluciones",
      cancellation: "Política de cancelación",
      shipping: "Política de envío",
    },
  },
  cookie: {
    title: "Cookies, con tu permiso",
    body: "Usamos cookies esenciales para que el sitio funcione. Con tu consentimiento, también usamos cookies de analítica para mejorarlo.",
    accept: "Aceptar todas",
    reject: "Solo esenciales",
    policy: "Política de privacidad",
  },
  cta: {
    title: "¿Tienes un proceso que debería funcionar solo?",
    body: "Cuéntanos qué necesitas. Respondemos en menos de 7 horas.",
    primary: "Empezar a hablar",
    secondary: "Ver servicios",
  },
  home: {
    hero: {
      eyebrow: "Estudio de software y automatización con IA",
      titleA: "Creamos sistemas",
      titleB: "que trabajan por ti.",
      lede: "Agentes de IA, automatizaciones, webs y apps — diseñados, construidos y lanzados de principio a fin.",
      primary: "Iniciar proyecto",
      secondary: "Ver nuestro trabajo",
      tags: ["Agentes de IA", "Automatización", "Apps web", "Apps móviles", "Datos", "Vídeo con IA"],
    },
    marquee: ["Agentes de IA", "Sistemas RAG", "Automatización", "Sitios web", "Apps web", "Apps móviles", "Web scraping", "Vídeo con IA", "Python", "n8n"],
    stats: [
      { value: 4, suffix: "+", label: "años creando sistemas de IA" },
      { value: 100, suffix: "+", label: "flujos automatizados" },
      { value: 7, suffix: "h", label: "tiempo máximo de respuesta" },
    ],
    services: { label: "Qué hacemos", title: "Cuatro formas de ayudarte.", more: "Todos los servicios" },
    work: {
      label: "Trabajos",
      title: "Proyectos reales ya publicados.",
      intro: "Abre cualquier tarjeta para verlo en vivo.",
      nextLabel: "Tu proyecto",
      nextTitle: "Podría ser el siguiente.",
      nextBody: "Webs, apps y automatización, de principio a fin.",
      nextCta: "Cuéntanos",
      visit: "abrir el sitio en una pestaña nueva",
    },
    process: {
      label: "Cómo trabajamos",
      title: "De la idea al lanzamiento en cuatro pasos.",
      steps: [
        { title: "Descubrir", desc: "Una llamada gratuita para entender tu objetivo." },
        { title: "Definir", desc: "Un plan escrito y claro, con plazos." },
        { title: "Construir", desc: "Demos funcionales en cada hito." },
        { title: "Lanzar", desc: "Salida a producción y soporte después." },
      ],
    },
    testimonials: { label: "Clientes", title: "Lo que dicen nuestros clientes." },
  },
  services: {
    eyebrow: "Servicios",
    title: "Servicios enfocados en tu objetivo.",
    lede: "Cada proyecto empieza con una llamada gratuita.",
    timeline: "Plazo habitual",
    included: "Qué incluye",
    tools: "Herramientas",
    showTools: "Ver herramientas",
    hideTools: "Ocultar herramientas",
    options: "Formas de empezar",
    choose: "Elegir",
    discuss: "Habla con nosotros",
    extrasTitle: "También ofrecemos",
    extras: ["Consultoría de IA", "Diseño de arquitectura", "Integración de APIs", "Cloud y DevOps", "Mantenimiento y soporte", "Ingenieros dedicados"],
    items: {
      "ai-automation": {
        title: "Automatización con IA",
        tagline: "Agentes y asistentes que quitan trabajo repetitivo a tu equipo.",
        timeline: "2–12 semanas",
        includes: ["Mapeo de procesos", "Chatbots y agentes de IA", "Asistentes de conocimiento (RAG)", "Integración con CRM y herramientas", "30 días de soporte"],
        plans: [
          { name: "Automatización inicial", note: "Un flujo · 2–3 semanas" },
          { name: "Suite de automatización", note: "Varios flujos · 4–6 semanas" },
          { name: "Sistemas de IA empresariales", note: "Integración total · 8–12 semanas" },
        ],
      },
      "web-development": {
        title: "Webs y apps web",
        tagline: "Sitios y apps rápidos, modernos y fáciles de gestionar.",
        timeline: "1–10 semanas",
        includes: ["Diseño UI/UX", "Desarrollo adaptable", "Panel de administración", "SEO y rendimiento", "60 días de soporte"],
        plans: [
          { name: "Web corporativa estática", note: "5–7 páginas · 1–2 semanas" },
          { name: "Web dinámica con panel", note: "Panel admin · 3–4 semanas" },
          { name: "App web a medida", note: "Funciones a medida · 6–10 semanas" },
        ],
      },
      "python-automation": {
        title: "Python y datos",
        tagline: "Scripts, scrapers y pipelines que funcionan solos.",
        timeline: "3 días–4 semanas",
        includes: ["Scripts a medida", "Web scraping", "Procesamiento de datos", "Tareas programadas", "Registros y documentación"],
        plans: [
          { name: "Script de automatización", note: "Una tarea · 3–5 días" },
          { name: "Solución de web scraping", note: "Varias páginas · 1–2 semanas" },
          { name: "Pipeline de datos complejo", note: "Varias fuentes · 2–4 semanas" },
        ],
      },
      "ai-video": {
        title: "Vídeo y avatares con IA",
        tagline: "Contenido en vídeo a gran escala, sin editores.",
        timeline: "2–10 semanas",
        includes: ["Avatares a medida", "Síntesis de voz", "Pipeline de guion a vídeo", "Estilo de marca", "Formación del equipo"],
        plans: [
          { name: "Vídeo con IA básico", note: "Un avatar · 2–3 semanas" },
          { name: "Sistema de avatares profesional", note: "Clonación de voz · 4–5 semanas" },
          { name: "Plataforma de vídeo empresarial", note: "API y marca blanca · 6–10 semanas" },
        ],
      },
    },
  },
  about: {
    eyebrow: "Nosotros",
    title: "Un equipo pequeño que crea IA práctica.",
    lede: "Sustituimos trabajo repetitivo por sistemas fiables — de un script a una plataforma completa.",
    storyLabel: "Nuestra historia",
    story: "Creamos Optivra Tech para llevar la IA moderna al día a día de las empresas. Primero entendemos cómo trabajas; después construimos lo que encaja.",
    valuesLabel: "Lo que nos guía",
    values: [
      { title: "Misión", desc: "Crecimiento medible con IA y automatización prácticas." },
      { title: "Visión", desc: "El socio tecnológico en el que confían las empresas que crecen." },
      { title: "Compromiso", desc: "Trabajo de calidad, comunicación clara, resultados reales." },
    ],
    skillsLabel: "Experiencia",
    skillsTitle: "En qué somos buenos.",
    skillsHint: "Pasa el cursor o toca una tarjeta para ver las herramientas.",
    skills: [
      { title: "IA y ML", tools: "OpenAI · LangChain · RAG · PyTorch" },
      { title: "Backend", tools: "Python · FastAPI · Node.js · Django" },
      { title: "Frontend", tools: "React · Next.js · TypeScript · Tailwind" },
      { title: "Datos", tools: "MongoDB · PostgreSQL · Redis · Pinecone" },
      { title: "Cloud", tools: "AWS · Google Cloud · Azure · Docker" },
      { title: "Automatización", tools: "n8n · Selenium · Scrapy · Airflow" },
    ],
    teamLabel: "El equipo",
    team: ["Ingenieros de IA y automatización", "Desarrolladores full-stack", "Arquitectos de soluciones", "Ingenieros DevOps"],
    whyLabel: "Por qué nosotros",
    why: [
      { title: "Rápidos", desc: "Ciclos cortos, demos funcionales." },
      { title: "Actuales", desc: "Herramientas probadas y al día." },
      { title: "Limpios", desc: "Código documentado y mantenible." },
    ],
  },
  contact: {
    eyebrow: "Contacto",
    title: "Hablemos.",
    lede: "Cuéntanos tu proyecto. Respondemos en menos de 7 horas.",
    name: "Nombre completo",
    email: "Correo electrónico",
    phone: "Teléfono",
    subject: "Asunto",
    subjectPh: "p. ej. Automatizar facturas",
    message: "Mensaje",
    messagePh: "¿Qué necesitas y qué herramientas usas?",
    send: "Enviar mensaje",
    sending: "Enviando…",
    privacy: "Nunca compartimos tus datos.",
    okTitle: "Mensaje enviado",
    okBody: "¡Gracias! Responderemos en menos de 7 horas.",
    errTitle: "Algo salió mal",
    errBody: "No se pudo enviar el mensaje. Inténtalo de nuevo.",
    emailLabel: "Correo",
    phoneLabel: "Teléfono",
    hoursLabel: "Horario",
    hours: "Lun–Sáb, 9:00–19:00 IST",
  },
  checkout: {
    eyebrow: "Iniciar proyecto",
    title: "Cuéntanos qué necesitas.",
    lede: "Elige la opción más cercana. Confirmaremos el alcance contigo.",
    details: "Tus datos",
    project: "Proyecto",
    name: "Nombre completo",
    company: "Empresa",
    email: "Correo electrónico",
    phone: "Teléfono",
    service: "Servicio",
    selectService: "Selecciona un servicio",
    option: "Opción",
    selectOption: "Selecciona una opción",
    notes: "Notas del proyecto",
    notesPh: "¿Qué debe hacer? ¿Con qué herramientas debe conectarse?",
    agree: "Acepto los",
    and: "y la",
    submit: "Enviar solicitud",
    submitting: "Enviando…",
    summary: "Resumen",
    summaryService: "Servicio",
    summaryOption: "Opción",
    next: "Respondemos en menos de 7 horas para confirmar alcance y próximos pasos.",
    empty: "Selecciona un servicio y una opción.",
    perks: ["Proceso seguro", "Reembolso en 7 días", "Respuesta en menos de 7 horas"],
    refundLink: "Política de reembolso",
    termsTitle: "Términos requeridos",
    termsBody: "Acepta los términos para continuar.",
    okTitle: "Solicitud recibida",
    okBody: "¡Gracias! Te contactaremos en menos de 7 horas.",
    errTitle: "Algo salió mal",
    errBody: "No se pudo enviar la solicitud. Inténtalo de nuevo.",
  },
  guide: {
    eyebrow: "Guías",
    title: "Guías prácticas basadas en proyectos reales.",
    lede: "Manuales paso a paso sobre IA, automatización y carrera profesional.",
    badges: ["Descarga PDF inmediata", "Copia por correo", "Pago seguro con PhonePe"],
    listLabel: "Guías disponibles",
    listTitle: "Elige una guía.",
    mins: "min",
    levels: { "All Levels": "Todos los niveles", Beginner: "Principiante", Intermediate: "Intermedio", Advanced: "Avanzado" },
    choose: "Elegir",
    selected: "Elegida",
    items: {
      g0: "Un plan de 30–45 días para conseguir tu empleo: CV, entrevistas y contactos.",
      g1: "Modelos de difusión, nodos personalizados y prototipado rápido en ComfyUI.",
      g2: "Crea sistemas autónomos que sustituyen tareas manuales.",
      g3: "Bases vectoriales, fragmentación y despliegue de agentes de conocimiento.",
      g4: "Aloja n8n y crea flujos entre apps con webhooks.",
    },
    buyLabel: "Pago",
    buyTitle: "Consigue tu copia.",
    buySub: "Se usa para tu factura y para enviarte el enlace de descarga.",
    name: "Nombre completo",
    phone: "Teléfono",
    email: "Correo electrónico",
    country: "País",
    countries: { India: "India", "United States": "Estados Unidos", "United Kingdom": "Reino Unido", Canada: "Canadá", Australia: "Australia", Germany: "Alemania", Other: "Otro" },
    gst: "Número GST",
    company: "Nombre de la empresa",
    agree: "Acepto los",
    and: "y la",
    terms: "Términos y condiciones",
    refund: "Política de reembolso",
    pay: "Pagar {amount} de forma segura",
    redirecting: "Redirigiendo al pago…",
    buying: "Vas a comprar",
    format: "Guía en PDF · descarga digital",
    price: "Precio",
    gstLine: "GST ({percent}%)",
    total: "Total",
    loadingPrice: "Cargando precio…",
    methods: "Paga con UPI, tarjeta, banca online o monedero.",
    secure: "PhonePe procesa los pagos de forma segura.",
    faqLabel: "Preguntas",
    faqTitle: "Preguntas frecuentes.",
    faqs: [
      { q: "¿En qué formato llegan las guías?", a: "Un PDF con diagramas, código e instrucciones paso a paso." },
      { q: "¿Cuándo la recibo?", a: "Al instante. Irás a una página de descarga y recibirás una copia por correo." },
      { q: "¿Puedo pedir un reembolso?", a: "Son descargas digitales inmediatas, así que los reembolsos son limitados. Consulta la Política de reembolso." },
      { q: "¿Quién escribe las guías?", a: "Nuestros ingenieros, a partir de los sistemas que crean para clientes." },
    ],
    errors: {
      "Full name is required": "El nombre completo es obligatorio",
      "Email is required": "El correo es obligatorio",
      "Please enter a valid email": "Introduce un correo válido",
      "Phone number is required": "El teléfono es obligatorio",
      "Please enter a valid phone number": "Introduce un teléfono válido",
      "You must accept the terms": "Debes aceptar los términos",
      "Something went wrong. Please try again.": "Algo salió mal. Inténtalo de nuevo.",
    },
  },
  success: {
    verifying: "Confirmando tu pago…",
    pending: "El pago aún se está procesando",
    checking: "Comprobando de nuevo automáticamente ({n}/10)",
    checkAgain: "Comprobar de nuevo",
    paid: "Pago recibido. ¡Gracias!",
    downloads: "Tus descargas",
    dlGuide: "Descargar guía (PDF)",
    dlInvoice: "Descargar factura (PDF)",
    linksNote: "Los enlaces son válidos 24 horas. También te enviamos una copia por correo.",
    expired: "Este enlace de descarga ha caducado",
    failed: "No pudimos completarlo",
    support: "Contactar con soporte",
    home: "Volver al inicio",
    errors: {
      "No order ID found. Please check your payment email for order details.": "No se encontró el pedido. Revisa el correo de pago para ver los detalles.",
      "Payment failed. Please try again.": "El pago falló. Inténtalo de nuevo.",
      "Unable to verify payment status.": "No se pudo verificar el estado del pago.",
      "Download links have expired after 24 hours.": "Los enlaces de descarga caducaron tras 24 horas.",
      "Unable to fetch download links.": "No se pudieron obtener los enlaces de descarga.",
      "Download failed. Please try again or contact support.": "La descarga falló. Inténtalo de nuevo o contacta con soporte.",
      "Something went wrong.": "Algo salió mal.",
    },
  },
  legal: { notice: "Esta política se publica en inglés, que es la versión legalmente vinculante." },
  work: {
    kke: { kind: "Web para cliente", summary: "Catálogo multilingüe para un proveedor industrial que exporta a todo el mundo.", highlights: ["Inglés, francés y árabe", "12 líneas de producto", "Presupuestos y WhatsApp"] },
    pokemac: { kind: "Producto propio · app macOS", summary: "Una app divertida de barra de menús que reacciona a golpes, a la tapa y al USB.", highlights: ["macOS nativo", "Funciona en el dispositivo"] },
    drillbuddy: { kind: "Producto propio · app Android", summary: "Ejercicios de reacción por audio para lucha, MMA y bádminton.", highlights: ["Google Play", "Intensidad ajustable"] },
    prayer: { kind: "Producto propio · app Android", summary: "Un contador de oraciones sereno, con temas y progreso diario.", highlights: ["8 idiomas", "Google Play"] },
  },
};

export default es;
